<script setup>
import { ref } from 'vue'
import { useAuthStore } from '../stores/auth.store'
import axios from 'axios'
import router from '@/router'

let apachePassword = '560285' //12345678

let dataUrl = `https://vngx01.ivn1.ru/aa/hs/defect-detection-service/list/`
//let dataUrl = `https://aa6.bazis-motors.ru/aa/hs/defect-detection-service/list/`

let list = ref([])
let doc_loaded = ref(false)

const $auth = useAuthStore()

//console.log($auth.token)

const axiosConfig = {
  headers: {
    Authorization2: `Bearer ${$auth.token}`
  },
  auth: {
    username: 'НеженецИИ', // apache
    password: apachePassword
  }
}

//console.log(this.$settings.axiosAuth)

fetchCarInspectParams()

async function fetchCarInspectParams() {
  doc_loaded.value = false
  try {
    axios
      .get(dataUrl, axiosConfig)
      .then(function (response) {
        console.log(response)
        list.value = response.data.docs
        doc_loaded.value = true
      })
      .catch(function (error) {
        console.log('catch')
        console.log(error)
        if (error.response.status === 401) {
          router.push('/auth')
        }
      })
  } catch (e) {
    alert('Error')
  }
}
</script>

<template>
  <div v-if="!doc_loaded" class="loader">
    <v-progress-circular color="purple" indeterminate></v-progress-circular>
    <span class="text">Загрузка</span>
  </div>
  <div v-if="doc_loaded" id="doc-inspect">
    <h1>Список документов</h1>
    <div class="buttons">
      <v-btn prepend-icon="mdi-refresh" @click="fetchCarInspectParams"> Обновить </v-btn>
    </div>
    <ul class="documents-list">
      <li v-for="item in list" :key="item.guid">
        <a v-bind:href="`/doc/${item.guid}`">{{ new Date(item.Дата * 1000).toLocaleDateString() }} {{ item.Шаблон }} -
          {{ item.Модель }} {{ item.АвтомобильЦвет }} ({{ item.АвтомобильГодВыпуска }}) {{ item.АвтомобильVIN }} -
          {{ item.Контрагент }}
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="less" scoped>
header {
  line-height: 1.5;

  p {
    color: #00bd7e;
  }
}

.loader {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    margin-left: 10px;
    font-size: 1.2rem;
  }
}

.buttons {
  margin: 20px 0;

  button.v-btn {
    margin: 10px;
  }
}

.documents-list {
  margin-top: 20px;

  li {
    list-style: none;
    margin: 5px 0;
  }
}
</style>
